module.exports = __webpack_public_path__ + "static/img/guiji.38b8ecf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guiji.jpg
// module id = m81R
// module chunks = 0